






























import Vue from 'vue';
import { Route } from 'vue-router';
import Pagination from '@/components/Pagination.vue';
import UserIcon from '@/components/UserIcon.vue';

export default Vue.extend({
  name: 'BestTeachers',
  components: {
    Pagination,
    UserIcon,
  },
  props: {
    page: {
      type: String,
      default: '1',
    },
  },
  data() {
    return {
      count: 0,
      limit: 16,
      teachers: null,
    };
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    $route: 'routeChanged',
  },
  methods: {
    fetchData() {
      window.scrollTo(0, 0);

      // Reassign this scope for callback usage
      const component = this;

      // Calculated offset based on page
      const offset = (parseInt(this.page, 10) - 1) * this.limit;

      if (offset < 0) {
        this.$router.push({
          name: 'bestTeachers',
          params: {
            page: '1',
          },
        });
        return;
      }

      fetch(`https://api.pocketyoga.com/charts/best-teachers?limit=${this.limit}&offset=${offset}&count=true`, {
        headers: { version: '5' },
      })
        .then((response) => {
          if (!response.ok) {
            throw response;
          }

          return response.json();
        })
        .then((json) => {
          component.teachers = json.data;
          component.count = json.count;

          // If we've past the last page then wrap to first
          if (offset >= component.count) {
            this.$router.push({
              name: 'bestTeachers',
              params: {
                page: '1',
              },
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onPageChange(page: Number) {
      this.$router.push({
        name: 'bestTeachers',
        params: {
          page: page.toString(),
        },
      });
      this.teachers = null;
    },
    routeChanged() {
      this.fetchData();
    },
  },
});
